import type { LanguageCode } from '@/utils/languages/supportedLanguages';

/** Bump when chrome bundle key selection changes (invalidates stale React Query caches). */
export const HUB_UI_TRANSLATIONS_BUNDLE_VERSION = 3;

export const HUB_UI_TRANSLATIONS_QUERY_KEY_ROOT = 'hub-ui-i18n-bundle';

export function hubUiTranslationsQueryKey(
  locale: LanguageCode,
  scopeKey: string
): [
  typeof HUB_UI_TRANSLATIONS_QUERY_KEY_ROOT,
  typeof HUB_UI_TRANSLATIONS_BUNDLE_VERSION,
  LanguageCode,
  string
] {
  return [
    HUB_UI_TRANSLATIONS_QUERY_KEY_ROOT,
    HUB_UI_TRANSLATIONS_BUNDLE_VERSION,
    locale,
    scopeKey,
  ];
}
